import { ParagraphText, TextAction } from '@leagueplatform/genesis-core';
import { useIntl } from '@leagueplatform/locales';
import { INTERNAL_LINKS } from 'common/links';

export const SignInFooter = () => {
  const { formatMessage } = useIntl();

  return (
    <ParagraphText size="sm" css={{ marginTop: '$two', textAlign: 'center' }}>
      <TextAction
        href={INTERNAL_LINKS.POLICY}
        size="medium"
        css={{
          fontWeight: '$bodyOne !important',
        }}
      >
        {formatMessage({ id: 'STR_PRIVACY_POLICY' })}
      </TextAction>
      {` ${formatMessage({ id: 'STR_AND' })} `}
      <TextAction
        href={INTERNAL_LINKS.TERMS}
        size="medium"
        css={{
          fontWeight: '$bodyOne !important',
        }}
      >
        {formatMessage({ id: 'STR_TERMS_OF_SERVICE' })}
      </TextAction>
    </ParagraphText>
  );
};
